import React from 'react';
import { useStyles } from './DealerInfo.styles';
import { Grid, useTheme } from '@mui/material';
import {
  LinkButton,
  LinkButtonType,
} from 'components/Global/LinkButton/LinkButton';
import { Icon, Icons } from 'components/Global/Icon/Icon';
import { appPalette } from 'theme/App.palette';
import { useDispatch } from 'react-redux';
import { removeSelectedDealer } from 'redux/slices/dealerSlice';
import { DealerInfoCard } from 'components/DealerLocator/DealerInfo/DealerInfoCard/DealerInfoCard';
import TextRender from 'components/Global/TextRender/TextRender';
import { Dealer } from 'interfaces/dealerLocator';

// Constants
const dealerLockKeyName = 'dealerLockID';
const trueString = 'true';

export interface IDealerInfo {
  dealer?: Dealer;
  hideChangeDealer?: boolean;
}

export function DealerInfo({
  dealer,
  hideChangeDealer,
}: IDealerInfo): JSX.Element {
  const classes = useStyles();
  const { iconMainColor } = appPalette.colors;
  const theme = useTheme();
  const isHondaThemed = theme.themeName === 'honda';
  const dispatch = useDispatch(); // redux dispatch
  const dealerLockID = sessionStorage.getItem(dealerLockKeyName);

  if (dealer) {
    return (
      <Grid
        container
        direction='row-reverse'
        className={`${classes.root} dealer-info ${
          hideChangeDealer ? classes.noChangeDealer : ''
        }`}
      >
        <Grid item xs={12} md={6}>
          {!hideChangeDealer && dealerLockID !== trueString && (
            <LinkButton
              dataAutomation={'CHANGE DEALER'}
              key={'changeDealer'}
              variant={LinkButtonType.text}
              isExternal={false}
              trackEventData={{
                label: `Change dealer`,
                category: {
                  includePageName: true,
                  text: '',
                },
                type: 'cta',
              }}
              classNames={{
                container: `${classes.dealerTextButtonContainer} t-change-dealer-button`,
              }}
              onClick={() => {
                dispatch(removeSelectedDealer());
              }}
            >
              <span>
                <TextRender
                  className={`${isHondaThemed ? 'atm-caption-7' : ''}`}
                  text={'CHANGE DEALER'}
                />
                <Icon
                  type={Icons.arrow}
                  className={classes.dealerCTASvg}
                  color={iconMainColor}
                />
              </span>
            </LinkButton>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <DealerInfoCard dealer={dealer} />
        </Grid>
      </Grid>
    );
  }
  return <></>;
}
